import { green, red } from "@ant-design/colors"
import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Space, Typography } from "antd"

export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^\da-zA-Z]).{8,}$/
const MatchIcon = ({ isMatch }: { isMatch: boolean }) => {
  if (isMatch) {
    return <FontAwesomeIcon icon={faCheck} color={green.primary} />
  }
  return <FontAwesomeIcon icon={faTimes} color={red.primary} />
}

export type Props = {
  password: string
  textColor?: string
}

export const PasswordRequirements = ({ password, textColor }: Props) => {
  return <Typography.Text style={{ color: textColor }}>
    The password must contain at least:
    <ul style={{ listStyleType: 'none' }}>
      <li>
        <Space>
          <MatchIcon isMatch={password && password.match(/[A-Z]/) !== null || false} />
          An upper case letter
        </Space>
      </li>
      <li>
        <Space>
          <MatchIcon isMatch={password && password.match(/[a-z]/) !== null || false} />
          A lower case letter
        </Space>
      </li>
      <li>
        <Space>
          <MatchIcon isMatch={password && password.match(/[^\da-zA-Z]/) !== null || false} />
          A special character
        </Space>
      </li>
      <li>
        <Space>
          <MatchIcon isMatch={password?.length >= 8} />
          8 or more characters
        </Space>
      </li>
    </ul>
  </Typography.Text>
}
